import { createFileRoute, redirect } from '@tanstack/react-router'
import { OpeningBalanceBatchScreen } from '@/features/accounting-opening-balances/opening-balance-batch-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/accounting/opening-balances/$batchId')({
  // Presentation only — the API enforces accounting_opening.view on every
  // read. Same key as the index guard and the rail entry.
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_opening.view')) {
      throw redirect({ to: '/accounting' })
    }
  },
  component: OpeningBalanceBatchRoute,
})

function OpeningBalanceBatchRoute() {
  const { batchId } = Route.useParams()

  return <OpeningBalanceBatchScreen batchId={batchId} />
}
